import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import moment from 'moment';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class CouponEvents extends Component {
    renderEvents() {
        if (this.props.events.length > 0) {
            return (
                <div className="table-responsive" style={{ height: 300 }}>
                    <table id="couponEventsTbl" className="showtix-table showtix-table__striped">
                        <thead>
                            <tr>
                                <th style={{ width: 20 }}>
                                    <div className="showtix-form__checkbox">
                                        <input
                                            type="checkbox"
                                            className="showtix-input"
                                            id="input-event-all"
                                            value="true"
                                            onChange={this.props.selectAllEventCheckboxes}
                                        />
                                        <label className="showtix-label" htmlFor="input-event-all"></label>
                                    </div>
                                </th>
                                <th>{strings.eventsTable.event}</th>
                                <th>{strings.eventsTable.dateAndTime}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.events.map((event, i) => {
                                    const displayedDate = (event.date != "") ? `${moment(event.date).format('dddd MMMM Do, YYYY')}` : "";
                                    const displayedTime = (event.date != "") ? `${moment(event.date).format('h:mm A')}` : "";
                                    return (
                                        <tr key={i}>
                                            <td style={{ width: 20 }}>
                                                <div className="showtix-form__checkbox">
                                                    <input
                                                        type="checkbox"
                                                        className="showtix-input"
                                                        id={"input-event-" + event.id}
                                                        value={event.id}
                                                        checked={this.props.selectedEvents.indexOf(event.id) != -1}
                                                        onClick={this.props.updateSelectedEvents}
                                                    />
                                                    <label className="showtix-label" htmlFor={"input-event-" + event.id}></label>
                                                </div>
                                            </td>
                                            <td>
                                                {event.name} 
                                            </td>
                                            <td>
                                                {displayedDate}<br />
                                                {displayedTime}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div> 
            );
        } else {
            return (
                <p>{strings.noEvents}</p>
            );
        }
    }

    render() { 
        let buttonLabel = (this.props.couponExists) ? strings.saveBtn : strings.createBtn;
        return ( 
            <div className={this.props.isSecondStepOpen === true ? "showtix-coupon-form__second-step is-active" : "showtix-coupon-form__second-step"}>
                <div className={"showtix-section showtix-section__padding-1 showtix-background__primary-1 " + (this.props.events.length > 0 ? 'open' : 'collapsed')}>
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h1 className="mb-2">{strings.title}</h1>
                                <h3 className="showtix-font-weight-light">{strings.subTitle}</h3>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-lg-9 text-left">
                                { this.renderEvents() }
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-12 col-md-12">
                                <button 
                                    className="showtix-button showtix-background__primary-2"
                                    onClick={this.props.saveCoupon}
                                    disabled={!this.props.isReadyToSubmit}>
                                    {buttonLabel}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>    
        )
    }
}

CouponEvents.propTypes = {
    events: PropTypes.array,
    isReadyToSelectEvents: PropTypes.bool,
    updateSelectedEvents: PropTypes.func
}
 
export default CouponEvents;


// WEBPACK FOOTER //
// ./src/components/CreateCoupon/CouponEvents/CouponEvents.js